import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "@/lib/api";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-ink-deep border-t border-gold/15 pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <img
              src={LOGO_URL}
              alt="7 Generations Indigenous Trust"
              className="w-full max-w-[300px] object-contain -ml-2"
            />
            <p className="font-sans text-sm text-[#A19D98] leading-relaxed mt-8 max-w-md">
              A private institutional framework for unrepresented Woodland Mississippian
              descendants and Modern Freedmen — securing our heritage through decentralized
              sovereignty.
            </p>
            <p className="font-mono text-[11px] tracking-[0.28em] uppercase text-gold/70 mt-8">
              Preservation • Stewardship • Prosperity
            </p>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <h4 className="font-mono text-[10px] tracking-[0.3em] uppercase text-gold/60 mb-6">Institution</h4>
            <ul className="space-y-4">
              {[
                ["Our Mission", "/mission"],
                ["Eligibility & Lineage", "/eligibility"],
                ["The Institution", "/institution"],
                ["Membership", "/membership"],
                ["Tribal Records Repository", "/tribal-portal"],
              ].map(([label, to]) => (
                <li key={label}>
                  <Link to={to} className="font-sans text-sm text-[#A19D98] hover:text-gold transition-colors duration-300">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-mono text-[10px] tracking-[0.3em] uppercase text-gold/60 mb-6">Access</h4>
            <ul className="space-y-4">
              {[
                ["Verify Genealogy", "/eligibility?tab=verify"],
                ["Order Membership ID", "/membership?tab=order"],
                ["The Vault (Login)", "/login"],
                ["Tribal Government Login", "/tribes/login"],
                ["Credential Verification", "/credential-verification"],
                ["Contact / Inquire", "/contact"],
              ].map(([label, to]) => (
                <li key={label}>
                  <Link to={to} className="font-sans text-sm text-[#A19D98] hover:text-gold transition-colors duration-300">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="gold-hairline my-12" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#6b6862]">
            © {new Date().getFullYear()} 7 Generations Indigenous Trust — Sovereign & Private
          </p>
          <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#6b6862]">
            Decentralized Blockchain Ancestry Registry
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 mt-8" data-testid="footer-legal">
          {[
            ["Privacy Policy", "/privacy"],
            ["Terms of Service", "/terms"],
            ["Accessibility Statement", "/accessibility"],
          ].map(([label, to]) => (
            <Link
              key={label}
              to={to}
              data-testid={`footer-legal-${to.slice(1)}`}
              className="font-mono text-[10px] tracking-[0.18em] uppercase text-[#6b6862] hover:text-gold transition-colors duration-300"
            >
              {label}
            </Link>
          ))}
        </div>
      </div>
    </footer>
  );
}
